import "firebase/firestore";
import { fireStoreDbInstance } from ".";
import firebase from "firebase/app";

export const COLLECTIONS = {
  USERS: "users",
  ADDRESSES: "addresses",
  DOCUMENTS: "documents",
  VECHICLES: "vehicles",
};

export async function setDoc(uid: string, data = {}, collection: string) {
  try {
    if (!uid) {
      throw new Error("Need Uid");
    }
    if (!Object.entries(data).length) {
      throw new Error("Please Provide atleast one value");
    }
    if (!collection) {
      throw new Error("Need Collection");
    }
    const docExists: any = await getDoc(uid, collection);

    if (docExists.exists) {
      throw new Error("Doc Already Exists");
    }
    const db = await fireStoreDbInstance();
    return await db
      .collection(collection)
      .doc(uid)
      .set(data)
      .then(() => {
        console.error("Document successfully written!");
      })
      .catch((error: any) => {
        console.error("Error Creating document: ", error);
        throw new Error(error);
      });
  } catch (error: any) {
    console.error(error.message);
  }
}

export async function updateDoc(uid: string, data = {}, collection: string) {
  try {
    if (!uid) {
      throw new Error("Need Uid");
    }
    if (!Object.entries(data).length) {
      throw new Error("Please Provide atleast one value");
    }
    if (!collection) {
      throw new Error("Need Collection");
    }
    const db = await fireStoreDbInstance();
    var docRef = await db.collection(collection).doc(uid);
    if (!docRef) {
      throw new Error("No user Found with provided id");
    }
    return await docRef
      .update(data)
      .then(() => {
        console.error("Document successfully updated!");
      })
      .catch((error: any) => {
        // The document probably doesn't exist.
        console.error("Error updating document 1: ", error);
      });
  } catch (error: any) {
    console.error(error.message);
  }
}

export async function getDoc(uid: string, collection: string) {
  try {
    if (!uid) {
      throw new Error("Need UID to search Doc.");
    }
    if (!collection) {
      throw new Error("Need Collection");
    }
    const db = await fireStoreDbInstance();
    const docRef = await db.collection(collection).doc(uid);

    // console.log("firebase 88 ====");

    return await docRef
      .get()
      .then((doc: any) => {
        // console.log("GET Doc ====", doc);
        if (doc.exists) {
          return { exists: true, data: doc.data() };
        }

        // console.log("firebase 88 ====", doc);

        return { exists: false, error: "No Document Found" };
      })
      .catch((error: Error) => {
        console.error("Error getting document:", error);
        throw error;
      });
  } catch (error: any) {
    console.error(error.message);
  }
}

export async function getSubCollectionData(uid: string, collection: string, subColletion: string) {
  const db = await fireStoreDbInstance();

  // console.log("firebase 106 ====");

  return await db
    .collection(`/${collection}/${uid}/${subColletion}`)
    .get()
    .then((array: any) => {
      var data: any = [];
      data = array.docs.map((doc: any) => ({
        ...doc.data(),
        ...{ did: doc.id },
      }));

      // console.log("firebase 106 ====", data);

      return { data };
    })
    .catch((error: any) => {
      console.error("getSubCollectionData: ", error);
    });
}

export async function saveSubCollectionData(
  uid: string,
  collection: string,
  subColletion: string,
  data = {},
  defaultRef?: string,
) {
  const db = await fireStoreDbInstance();
  const docRef = (window as any).Firestore
    ? await db.collection(`${collection}/${uid}/${subColletion}`)
    : await db.collection(collection).doc(uid).collection(subColletion);

  return await docRef
    .add(data)
    .then(async (docRef: any) => {
      const subCollectionData: any = await getSubCollectionData(uid, collection, subColletion);
      if (subCollectionData.data.length < 2) {
        if (subColletion === COLLECTIONS.ADDRESSES) {
          var post: any = {
            // test,
            // defaultAddressRef: db.doc(
            //   `${collection}/${uid}/${subColletion}/${docRef.id}`
            // ),
            defaultAddressRef: `${collection}/${uid}/${subColletion}/${docRef.id}`,
          };
        }
        if (subColletion === COLLECTIONS.VECHICLES) {
          var post: any = {
            // test,
            // defaultVehicleRef: db.doc(
            //   `${collection}/${uid}/${subColletion}/${docRef.id}`
            // ),
            defaultVehicleRef: `${collection}/${uid}/${subColletion}/${docRef.id}`,
          };
        }
        //get ref and store update ref at higher level
        await updateDoc(uid, post, COLLECTIONS.USERS);
      }
      return { did: docRef.id, success: true };
    })
    .catch((error: any) => {
      console.error("Error adding document: ", error);
    });
}

export async function setDefaultAddress(
  uid: string,
  did: string,
  collection: string,
  subColletion: string,
) {
  const db = await fireStoreDbInstance();
  const data = {
    // defaultAddressRef: db.doc(`${collection}/${uid}/${subColletion}/${did}`),
    defaultAddressRef: `${collection}/${uid}/${subColletion}/${did}`,
  };
  const userData: any = await getDoc(uid, COLLECTIONS.USERS);
  await updateDoc(uid, data, collection);
}

export async function updateVehicleRef(
  uid: string,
  did: string,
  collection: string,
  subColletion: string,
) {
  // console.log("firebase 188 ====");
  const db = await fireStoreDbInstance();
  const data = {
    // defaultVehicleRef: db.doc(`${collection}/${uid}/${subColletion}/${did}`),
    defaultVehicleRef: `${collection}/${uid}/${subColletion}/${did}`,
  };

  // console.log("firebase 188 ====", data);
  await updateDoc(uid, data, collection);
}

export async function updateDocument(
  uid: string,
  collection: string,
  subCollection: string,
  did?: string,
  data: any = {},
) {
  const db = await fireStoreDbInstance();
  var docRef = (window as any).Firestore
    ? await db.doc(`${collection}/${uid}/${subCollection}/${did}`)
    : await db.collection(collection).doc(uid).collection(subCollection).doc(did);
  return await docRef
    .update(data)
    .then((docRef: any) => {
      console.error("Document successfully updated!");
      return { success: true };
    })
    .catch((error: any) => {
      console.error("Error updating document 2: ", error);
    });
}

export async function saveDocumentData(
  uid: string,
  data: any = {},
  collection: string,
  subCollection: string,
  did?: string,
) {
  // console.log("Save Doc col ====", collection);
  // console.log("Save Doc data ====", data);
  // console.log("Save Doc sub ====", subCollection);

  if (!did) {
    return saveSubCollectionData(uid, collection, subCollection, data);
  } else {
    return updateDocument(uid, collection, subCollection, did, data);
  }
}

export async function getSubCollectionDocument(
  uid: string,
  collection: string,
  subCollection: string,
  did: string,
) {
  const db = await fireStoreDbInstance();
  var docRef = (window as any).Firestore
    ? await db.doc(`${collection}/${uid}/${subCollection}/${did}`)
    : await db.collection(collection).doc(uid).collection(subCollection).doc(did);

  // console.log("Get Doc sub ====");

  return await docRef
    .get()
    .then((doc: any) => {
      return { data: doc.data() };
    })
    .catch((error: any) => {
      // The document probably doesn't exist.
      console.error("Error updating document 3: ", error);
    });
}

export async function deleteDataFromFireStore(
  uid: string,
  did: string,
  collection: string,
  subCollection: string,
) {
  const db = await fireStoreDbInstance();
  const docRef = (window as any).Firestore
    ? await db.doc(`${collection}/${uid}/${subCollection}/${did}`)
    : db.collection(collection).doc(uid).collection(subCollection).doc(did);

  return docRef
    .delete()
    .then(() => {
      console.error("Document successfully deleted!");
      return { success: true };
    })
    .catch((error: any) => {
      console.error("Error removing document: ", error);
      return { success: false, error };
    });
}

export async function deleteVehicleRef(uid: string, collection: string) {
  const db: any = await fireStoreDbInstance();
  const docRef = await db.collection(collection).doc(uid);
  var removeField = await docRef.update({
    defaultVehicleRef: firebase.firestore.FieldValue.delete(),
  });
}

export async function deleteAddressRef(uid: string, collection: string) {
  const db: any = await fireStoreDbInstance();
  const docRef = await db.collection(collection).doc(uid);
  var removeField = await docRef.update({
    defaultAddressRef: firebase.firestore.FieldValue.delete(),
  });
}
